import BulkDownload from './index.vue'

export default [
  {
    path: '/download',
    name: 'BulkDownload',
    component: BulkDownload
  }
]
